export default __webpack_public_path__ + "static/media/marke_2.c41a717a.png";